import * as React from 'react';
import { Alert } from 'reactstrap';
import { TR } from 'src/TextRes';
import { ServerResponse } from '../../api';
import './ErrorBox.css';

interface ErrorBoxProps {
    serverResponse: ServerResponse | undefined;
    listErrors?: boolean;
}

export default class ErrorBox extends React.Component<ErrorBoxProps> {
    public render() {
        if (this.props.serverResponse === undefined || this.props.serverResponse.OK) {
            return null;
        }

        const messages = {
            communication_error: TR.errorBox_server_error,
            error_email_in_use: TR.errorBox_email_exists,
            geo_accuracy_error: TR.errorBox_email_not_found,
            not_found: TR.errorBox_email_unknown,
            unauthorized: TR.errorBox_check_password,
            user_not_found: TR.errorBox_email_unknown2,
            validation_error: TR.errorBox_check_data,
        };
        return <Alert color="danger">{messages[this.props.serverResponse.Error]}</Alert>;
    }
}



// WEBPACK FOOTER //
// ./src/components/errorBox/ErrorBox.tsx